export default {
  black: '#333333',
  blackOpacity: 'rgba(51, 51, 51, 0.5)',
  white: '#ffffff',
  gray: '#707070',
  disabledGray: '#D9D9D9',
  smokeWhite: '#F4F4F4',
  smokeWhiteSecondary: '#FAFAFA',
  primary: '#3475D2',
  darkPrimary: '#20477F',
  primaryOpacity: 'rgba(52, 117, 210, 0.7)',
  option: '#5C8CD1',
  secondary: '#C85C83',
  secondaryOpacity: 'rgba(200, 92, 131, 0.5)',
  positive: '#34D286',
  negative: '#EA1A65',
};
